import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-end text-xxs2 flex-col mb-2" }

import { computed } from 'vue';
import { NkIcon } from '@/core/components';


export default /*#__PURE__*/_defineComponent({
  __name: 'NkPasswordError',
  props: {
  password: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



// const emit = defineEmits(['validation-change']);

const hasUppercase = computed(() => /[A-Z]/.test(props.password));
const hasLowercase = computed(() => /[a-z]/.test(props.password));
const hasNumber = computed(() => /[0-9]/.test(props.password));
const hasSpecial = computed(() => /[#?!@$%^&*-]/.test(props.password));
const hasLength = computed(() => props.password.length >= 8);

// watch([hasUppercase, hasLowercase, hasNumber, hasSpecial, hasLength], () => {
//   emit('validation-change', hasUppercase.value && hasLowercase.value && hasNumber.value && hasSpecial.value && hasLength.value);
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-danger block flex gap-x-1 items-center", {'text-success': _unref(hasLowercase)}])
    }, [
      _createVNode(_unref(NkIcon), {
        name: _unref(hasLowercase) ? 'NkDone' : 'NkClose'
      }, null, 8, ["name"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('forms.rules.shouldHaveLowercase', { min: 1 })), 1)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["text-danger flex gap-x-1 items-center", {'text-success': _unref(hasUppercase)}])
    }, [
      _createVNode(_unref(NkIcon), {
        name: _unref(hasUppercase) ? 'NkDone' : 'NkClose'
      }, null, 8, ["name"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('forms.rules.shouldHaveUppercase', { min: 1 })), 1)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["text-danger block flex gap-x-1 items-center", {'text-success': _unref(hasNumber)}])
    }, [
      _createVNode(_unref(NkIcon), {
        name: _unref(hasNumber) ? 'NkDone' : 'NkClose'
      }, null, 8, ["name"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('forms.rules.shouldHaveNumber', { min: 1 })), 1)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["text-danger block flex gap-x-1 items-center", {'text-success': _unref(hasSpecial)}])
    }, [
      _createVNode(_unref(NkIcon), {
        name: _unref(hasSpecial) ? 'NkDone' : 'NkClose'
      }, null, 8, ["name"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('forms.rules.shouldHaveSpecial')), 1)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["text-danger block flex gap-x-1 items-center", {'text-success': _unref(hasLength)}])
    }, [
      _createVNode(_unref(NkIcon), {
        name: _unref(hasLength) ? 'NkDone' : 'NkClose'
      }, null, 8, ["name"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('forms.rules.shouldHaveLength', { length: 8 })), 1)
    ], 2)
  ]))
}
}

})